import request from '@/utils/request'

export function sendSms (params) {
  return request({
    method: 'get',
    params: {
      do: 'sendSms',
      ...params
    }
  })
}
